import { render, staticRenderFns } from "./CrearPlanes.vue?vue&type=template&id=fa999c7e&scoped=true&"
import script from "./CrearPlanes.vue?vue&type=script&lang=js&"
export * from "./CrearPlanes.vue?vue&type=script&lang=js&"
import style0 from "./CrearPlanes.vue?vue&type=style&index=0&id=fa999c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa999c7e",
  null
  
)

export default component.exports